export enum ConfigApiEnum {
  HOST_LOCAL  = 'https://apibutaca.udg.mx',
  HOST_DEV    = 'https://apibutaca.udg.mx',
  // HOST_REMOTE = 'https://butaca.bsmx.site',
  HOST_REMOTE = 'https://apibutaca.udg.mx',
  WEB_CLIENT_ID = '903014995348-9if8c837dtbiiptim0tsf9octejdfbeh.apps.googleusercontent.com',
  WEB_CID = '433871374756-j67p25o88nmfqva8e6f2ldtg0gcoh6cp.apps.googleusercontent.com'
}
